var util = {
  // 字节换算
  formatByteText(v, n) {

    if (v === 0 || !v) return '0 B';

    var k = 1024;

    var sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    var i = Math.floor(Math.log(v) / Math.log(k));

    var nv = v / Math.pow(k, i);

    // toFixed(2) 保留两位小数
    if (!n) {
      n = 1
    }
    return nv.toFixed(n) + ' ' + sizes[i];
  },
  // 千位分割符
  thousandSeparator(v) {
    if (!v) {
      return 0
    }
    return v.toLocaleString()
  },
  // 随机数
  randomInt(length) {
    if (!length) {
      return 0
    }
    var str = '0123456789'
    var result = ''
    for (var i = length; i > 0; --i) { result += str[Math.floor(Math.random() * str.length)] }
    return result
  },
  // 随机数
  randomString(length) {
    if (!length) {
      return 0
    }
    var str = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
    var result = ''
    for (var i = length; i > 0; --i) { result += str[Math.floor(Math.random() * str.length)] }
    return result
  }
}

export default util
